module.exports = __webpack_public_path__ + "static/img/system_tc@2x.87297c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_us/system_tc@2x.png
// module id = 438
// module chunks = 0